<template>
  <div>
    <label :for="id">{{ label }}</label>
    <select
      :id="id"
      class="form__input form__input--solid form__input--select"
      :class="color ? `form__input--${color}` : false"
      @change="select"
    >
      <option
        disabled
        selected
        value=""
      >
        Auswahl treffen, um zu filtern
      </option>

      <option
        v-for="option in options"
        :key="option"
        :checked="option === value"
      >
        {{ option }}
      </option>

      <option disabled>
        ─────
      </option>

      <option value="">
        Filter löschen
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'CFilter',

  props: {
    id: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: undefined
    }
  },

  methods: {
    select (event) {
      if (!event.target.value) {
        event.target.selectedIndex = 0
      }

      this.$emit('input', event.target.value)
    }
  }
}
</script>
